import { useDispatch, useSelector } from "react-redux";
import { logoutData } from "../features/auth/logout/logoutSlice";
import { OK } from "../constants/statusCode";
import toggleImg from "../assets/images/toggle_icn.svg";
import chatBotImg from "../assets/images/chat-logo.svg";
import logoutImg from "../assets/images/logout.svg";
import switchArrow from "../assets/images/switch-arrow.svg";
import { clearSession } from "../utils/localSession";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import SwitchProjectModal from "../components/projectComponent/SwitchProjectModal";
import { getProfileData } from "../features/profile-management/getProfileDataSlice";
import editImg from "../assets/images/edit_project.svg";
import { getParticularProject } from "../features/projectManagement/getParticularProject";
// import { editProject } from "../features/projectManagement/editProjectSlice";
import { SocketContext } from "../socket/socket";
import EditProjectModal from "../components/setting-component/modal/EditProjectModal";
import NoDocumentsModal from "../common/modal/NoDocumentsModal";
import AddProjectModal from "../components/setting-component/modal/AddProjectModal";
import { getProjectList } from "../features/projectManagement/getProjectListSlice";
import { getDocuments } from "../features/user-document/documentListingSlice";
import { labelListing } from "../features/user-document/label-listing";
import { getSwitchProjectList } from "../features/projectManagement/switchProjectSlice";
import { RoleRightsForModule } from "../utils/utils";
/* import notifyicn from "../assets/images/notify_icn.svg"; */
/* import crossImg from "../assets/images/cross_icn.svg";
import writeImg from "../assets/images/writei_icn.svg"; */

const Header = ({ setIsToggle, isToggel }) => {
  const [activeProject, setActiveProject] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const {
    userData,
    ParticularProjectData,
    actualRecords,
    projectListing,
    switchProjectList,
  } = useSelector((state) => ({
    userData: state?.getProfileDataReducer?.profileData,
    ParticularProjectData: state?.getParticularProjectReducer?.responseData,
    actualRecords: state?.documentListing?.actualRecords,
    projectListing: state?.getProjectListReducer?.responseData?.projects,
    switchProjectList: state?.getSwitchProjectListSliceReducer?.responseData,
  }));

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [currentModal, setCurrentModal] = useState("");
  // const [value, setValue] = useState('');
  // const [editOpen, setEditOpen] = useState(false);
  // const [headerProjectData, setHeaderProjectData] = useState({});
  /* const socketContext = useContext(SocketContext); */
  // let projectName = JSON.parse(localStorage.getItem("_user")).projects[0].name;
  let projectData = JSON.parse(localStorage.getItem("_user"));

  /*  const handleLogout = async () => {
     const { payload } = await dispatch(logoutData());
     if (payload.status === OK) {
       clearSession();
       navigate("/login");
     }
     socketContext.socket.disconnect("disconnect", () => { });
   }; */
  useEffect(() => {
    dispatch(getProjectList({ perPage: 100, page: 1 })).then((res) => {
      if (
        !res?.payload?.data?.responseData?.projects.some(
          (obj) => obj.uuid === projectData.projects[0].uuid
        )
      ) {
        res?.payload?.data?.responseData?.projects.map((d) => {
          if (d?.uuid !== projectData.projects[0].uuid) {
            if (d?.Users[0]?.ProjectUser?.is_default === 1) {
              projectData.projects[0].uuid = d?.uuid;
              projectData.projects[0].name = d?.name;
              projectData.organizations[0].uuid = d?.Organizations[0]?.uuid;
              projectData.organizations[0].name = d?.Organizations[0]?.name;
              projectData.projects[0].slug = d?.slug;
              projectData.projects[0].website_logo = d?.website_logo;
              localStorage.setItem("_user", JSON.stringify(projectData));
            }
          }
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getSwitchProjectList({ search: searchValue }));
  }, [searchValue]);

  // useEffect(() => {
  //   dispatch(getProfileData(projectData?.organizations[0].uuid));
  // }, []);

  // useEffect(() => {
  //   dispatch(getParticularProject(projectData.projects[0].uuid));
  // }, []);

  // useEffect(() => {
  //   setHeaderProjectData(ParticularProjectData);
  // }, [ParticularProjectData]);

  // useEffect(() => {
  //   setValue(projectName);
  // }, [editOpen]);

  // const SwitchProjectToggle = () => {
  //   setCurrentModal("");
  // };

  // const onBlur = () => {
  //   // setEditOpen(!editOpen);
  //   projectData.projects[0].uuid = ParticularProjectData?.uuid;
  //   projectData.projects[0].name = value;
  //   projectData.projects[0].slug = ParticularProjectData?.slug;
  //   localStorage.setItem(
  //     "_user",
  //     JSON.stringify(projectData)
  //   );
  //   let formData = new FormData();
  //   let projectId = projectData.projects[0].uuid;
  //   formData.append("name", value);
  //   dispatch(editProject({ projectId, _data: formData }));
  // };

  // const onChange = async (e) => {
  //   setValue(e.target.value);
  // };

  const toggleFunction = () => {
    setCurrentModal("");
    // dispatch(resetParticularProjectData());
  };

  const handleEditPrject = () => {
    // setEditOpen(!editOpen);
    setCurrentModal("editProjectModal");
  };

  /*  const handleSaveProjectName = async () => {
     setEditOpen(!editOpen);
     projectData.projects[0].uuid = ParticularProjectData?.uuid;
     projectData.projects[0].name = value;
     projectData.projects[0].slug = ParticularProjectData?.slug;
     localStorage.setItem(
       "_user",
       JSON.stringify(projectData)
     );
     let formData = new FormData();
     let projectId = projectData.projects[0].uuid;
     formData.append("name", value);
     await dispatch(editProject({ projectId, _data: formData }));
   }; */

  const handleClick = async (data, organizationData) => {
    setActiveProject(data.name);
    projectData.projects[0].uuid = data?.uuid;
    projectData.projects[0].name = data?.name;
    projectData.organizations[0].uuid = organizationData?.uuid;
    projectData.organizations[0].name = organizationData?.name;
    projectData.projects[0].slug = data?.slug;
    projectData.projects[0].website_logo = data?.website_logo;
    /* if (!isChatPage) { */
    localStorage.setItem("_user", JSON.stringify(projectData));
    dispatch(getProfileData(projectData?.organizations[0].uuid));
    dispatch(
      getDocuments({
        perPage: 10,
        page: 1,
        project_uuid: projectData?.projects[0]?.uuid,
      })
    );
    await dispatch(labelListing(projectData?.projects[0]?.uuid));
  };

  return (
    <>
      <header className="header">
        <div className="row align-items-center justify-content-between header-row">
          <div className="col-12 col-sm-5 col-md-6 col-lg-6 col-xl-5 col-xxl-4">
            <div className="d-flex align-items-center">
              <button
                className="btn toggle-btn"
                onClick={() => {
                  setIsToggle(!isToggel);
                }}
              >
                <img src={toggleImg} alt="toggle_icn" />
              </button>

              {/* {editOpen === true && (
                <div className="rename-input header-title-input">
                  <input value={value} autoFocus onChange={onChange} onBlur={onBlur} className="form-control" />
                  <button
                    type="button"
                    className="btn write-btn bg-success"
                    disabled={value ? false : true}
                    onClick={() => { handleSaveProjectName() }}
                  >
                    <img src={writeImg} alt="write-btn-img" />
                  </button>
                  <button
                    type="button"
                    className="btn cross-btn bg-danger"
                    onClick={() => {
                      setValue("");
                      setEditOpen(!editOpen);
                    }}
                  >
                    <img src={crossImg} alt="cross-btn-img" className="cross-btn-img" />
                  </button>
                </div>
              )} */}
              {/* {editOpen === false &&
                <> */}
              {projectData.projects[0].website_logo && (
                <span className="edit-svgicn-btn cursor-pointer">
                  <img
                    height="22px"
                    width="22px"
                    src={`${process.env.REACT_APP_CLOUD_FRONT_URL}projects/${
                      projectData.projects[0].uuid
                    }/${
                      projectData.projects[0].website_logo
                    }?v=${new Date().getTime()}`}
                    alt="website logo"
                    className="edit-svgicn"
                  />
                </span>
              )}
              <h1 className="header-title header-input-title">
                {projectData.projects[0].name}
              </h1>
              <span
                className="edit-svgicn-btn cursor-pointer"
                onClick={handleEditPrject}
              >
                <img className="edit-svgicn" src={editImg} alt="edit" />
              </span>
              {/* </>
              } */}
            </div>
          </div>
          <div className="col-6 col-sm-7 col-md-6 col-lg-6 col-xl-7 col-xxl-8 text-end">
            <div className="d-flex justify-content-end header-right-btngrup align-items-center">
              {/* <a
                href={`http://52.7.137.156:3000/${
                  JSON.parse(localStorage.getItem("_user"))["projects"][0][
                    "slug"
                  ]
                }`}
                target="_blank"
              >
                <button className="btn btn-primary-md me-3 d-flex align-items-cetner">
                  <img src={chatBotImg} alt="" className="chat-btn-icon me-2" />{" "}
                  Chatbot
                </button>
              </a> */}

              {actualRecords > 0 && (
                <button
                  className="btn btn-primary-md"
                  onClick={() =>
                    /* actualRecords <= 0 ? setCurrentModal("noDocumentsModal") : */
                    navigate(`/chat/${projectData["projects"][0]["slug"]}`)
                  }
                >
                  <img src={chatBotImg} alt="" className="chat-btn-icon" />{" "}
                  Chatbot
                </button>
              )}

              {/* <div className="btn-group notify-dropdown">
                <button
                  type="button"
                  className="btn btn-secondary dropdown-toggle"
                // data-bs-toggle="dropdown"
                // aria-expanded="false"
                >
                  <img className="notify-icn" src={notifyicn} alt="ejimg" />
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <div className="notifymenu-header">
                    <p>Notifications</p>
                  </div>
                  <div className="notifymenu-body">
                    <span
                      className="nonot-found-txt"
                      style={{ display: "none" }}
                    >
                      No new Notifications found
                    </span>
                    <ul className="notification-list custom-scrollbar text-start">
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                      <li>
                        <a href="notify-list">Notification list 1</a>
                      </li>
                    </ul>
                  </div>
                  <div className="notifymenu-footer">
                    <button type="button" className="btn">
                      View all notifications
                    </button>
                  </div>
                </ul>
              </div> */}

              <div className="user-menu mt-1 me-0">
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="user-profile-text">
                      {`${userData?.first_name} ${userData?.last_name}`
                        .split(" ")
                        .map((n) => n[0])
                        .join("")
                        .toUpperCase()}
                      {/* {`${JSON.parse(localStorage.getItem("_user"))?.first_name
                        } ${JSON.parse(localStorage.getItem("_user"))?.last_name}`
                        .split(" ")
                        .map((n) => n[0])
                        .join("")
                        .toUpperCase()} */}
                    </div>
                    {/* <img src={ejImg} alt="ej_img" /> */}
                    <div className="user-drop-title">
                      <p>
                        {userData?.first_name} {userData?.last_name}
                      </p>
                      <span>{projectData.projects[0].name}</span>
                    </div>
                  </button>

                  <ul
                    className="dropdown-menu header-new-dropdown"
                    data-popper-placement="top-start"
                  >
                    <div className="header-right-inner-drop">
                      <div className="inner-drop-header text-center">{`Projects(${switchProjectList?.projectCount})`}</div>
                      <div className="inner-drop-body">
                        <div className="intro-searchbar-border">
                          <div className="intro-searchbar">
                            <button
                              disabled
                              type="button"
                              className="filter-search-btn"
                            ></button>
                            <input
                              type="text"
                              className="form-control"
                              name="search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                              }}
                              placeholder="Search"
                              value={searchValue}
                            />
                          {/*   <button type="button" class="btn search-reset-btn">
                              <svg
                                class="close-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="13.414"
                                height="13.414"
                                viewBox="0 0 13.414 13.414"
                              >
                                <g
                                  id="Group_31758"
                                  data-name="Group 31758"
                                  transform="translate(0.707 0.707)"
                                >
                                  <path
                                    id="Path_48155"
                                    data-name="Path 48155"
                                    d="M0,0,12,12"
                                    fill="none"
                                    stroke="#313b5c"
                                    stroke-width="2"
                                  ></path>
                                  <path
                                    id="Path_48154"
                                    data-name="Path 48154"
                                    d="M12,0,0,12"
                                    fill="none"
                                    stroke="#313b5c"
                                    stroke-width="2"
                                  ></path>
                                </g>
                              </svg>
                            </button> */}
                          </div>
                        </div>
                        <div className="inner-listing-body">
                          {switchProjectList?.organization?.length > 0 &&
                            switchProjectList?.organization?.map(
                              (data, index) => (
                                <div key={index} className="listing-body">
                                  <h5 className="listing-heading">
                                    {data?.name}
                                  </h5>
                                  {data?.Projects?.length > 0 &&
                                    data?.Projects.map((d, index) => (
                                      <span
                                        key={index}
                                        className={`listing-link ${
                                          projectData.projects[0].uuid ===
                                          d?.uuid
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={() => {
                                          handleClick(d, data);
                                        }}
                                      >
                                        {d.name}
                                      </span>
                                    ))}
                                  <hr />
                                </div>
                              )
                            )}
                        </div>
                      </div>
                      {RoleRightsForModule("Add", "Manage Projects") && (
                        <div className="inner-drop-footer">
                          <button
                            className="btn w-100"
                            onClick={() => setCurrentModal("addProjectModal")}
                          >
                            {" "}
                            Create project
                          </button>
                        </div>
                      )}
                    </div>
                  </ul>
                  {/* <ul
                    className="dropdown-menu"
                    data-popper-placement="top-start"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => setCurrentModal("switchModal")}
                      >
                        <img
                          className="dropdown-item-img"
                          src={switchArrow}
                          alt="plusicn"
                        />
                        Switch Project
                      </a>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleLogout()}
                      >
                        <img
                          className="dropdown-item-img"
                          src={logoutImg}
                          alt="logout"
                        />
                        Logout
                      </button>
                    </li>
                  </ul> */}
                </div>
              </div>
              {/* <button className="btn btn-primary-md">+ New category</button> */}
            </div>
          </div>
          {/* {currentModal === "switchModal" && */}
          {/* <SwitchProjectModal
            isOpen={currentModal === "switchModal"}
            toggle={toggleFunction}
            title={"Switch Project"}
            currentModal={currentModal}
            setCurrentModal={setCurrentModal}
          /> */}
          {/* } */}
          {currentModal === "editProjectModal" && (
            <EditProjectModal
              isVisible={currentModal === "editProjectModal"}
              toggleFunction={toggleFunction}
              projectId={projectData.projects[0].uuid}
              isFromHeader={true}
            />
          )}
          {currentModal === "addProjectModal" && (
            <AddProjectModal
              isVisible={currentModal === "addProjectModal"}
              toggleFunction={toggleFunction}
            />
          )}
          {/* {currentModal === "noDocumentsModal" && (
            <NoDocumentsModal
              isVisible={currentModal === "noDocumentsModal"}
              toggleFunction={toggleFunction}
            />
          )} */}
        </div>
      </header>
    </>
  );
};

export default Header;
